
import FreeShipping from "../component/freeshipping";
import ContactForm from "../component/contactForm";
import Breadcrumb from "../component/Breadcrumb";
import PageTitle from "../component/pageTitle";

function Contact()
{

    return(
        <>

        <PageTitle title="ثبت شکایات"/>
        <Breadcrumb />
        <ContactForm />
        <FreeShipping />
        
        </>
    );


}
export default Contact;
